"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _driver = _interopRequireDefault(require("./driver"));

var _default = (0, _driver["default"])('webExtensionLocalStorage', 'local');

exports["default"] = _default;